export default __webpack_public_path__ + "static/media/erikaImg.8504eb31.jpg";